import { baseApi } from './baseApi';
import { TypeFromApi, TypeFromStore } from '../interfaces';

const mapApiToStore = (item: TypeFromApi): TypeFromStore => ({
  id: item?.ID,
  name: item?.Name,
  displayName: item?.DisplayName,
  validation: item.Validation,
  schema: item?.Schema,
  createdAt: item?.CreatedAt,
  updatedAt: item?.UpdatedAt,
  deletedAt: item?.DeletedAt,
  cmsScopeId: item?.CmsScopeID,
});

export const typesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTypes: builder.query<TypeFromStore[], null>({
      query: () => `/types`,
      transformResponse: (result: any) => result.data.map(mapApiToStore),
      providesTags: () => [{ type: 'Types', id: 'LIST' }, { type: 'Types' }],
    }),
    getTypeBySlug: builder.query<TypeFromStore, { slug: string }>({
      query: ({ slug }) => `/types/${slug}`,
      transformResponse: (result: any) => mapApiToStore(result.data),
      providesTags: (result, error, { slug }) => [{ type: 'Types', id: slug }, { type: 'Types' }],
    }),
    getTypesByCmsScope: builder.query<TypeFromStore[], { cmsScopeId: number }>({
      query: ({ cmsScopeId }) => `/cms-scopes/${cmsScopeId}/types`,
      transformResponse: (result: any) => (result?.data ?? []).map(mapApiToStore),
      providesTags: (result, error, { cmsScopeId }) => [
        { type: 'Types', id: `CMS_SCOPE_${cmsScopeId}` },
        { type: 'Types' },
      ],
    }),
  }),
});

export const {
  useGetTypesQuery,
  useLazyGetTypesQuery,
  useGetTypeBySlugQuery,
  useGetTypesByCmsScopeQuery,
} = typesService;
